import styled, {css} from "styled-components"

import {spacingCss, SpacingProps as LocalSpacingProps} from "../global/css"

interface Props extends LocalSpacingProps {
  display?: "block" | "inline" | "inline-block" | "none"
  hideOnMobile?: boolean
  hideOnDesktop?: boolean
}

const Spacing = styled.div<Props>`
  ${({display}) => display && `display: ${display};`}
  ${({theme, hideOnMobile, hideOnDesktop}) => css`
    ${theme.mediaQueries.maxWidthMedia.tablet`
      ${hideOnMobile && "display: none;"}
    `}
    ${theme.mediaQueries.minWidthMedia.tablet`
      ${hideOnDesktop && "display: none;"}
    `}
  `}

  ${spacingCss}
`

export default Spacing
export type SpacingProps = LocalSpacingProps
